import { Box, Typography } from '../ui';

interface EmptyStateProps {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  sx?: any;
}

export default function EmptyState({ icon, title, subtitle, sx }: EmptyStateProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 10,
        px: 4,
        ...sx,
      }}
    >
      <Box
        sx={{
          width: 200,
          height: 200,
          borderRadius: '50%',
          bgcolor: 'grey.200',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 4,
        }}
      >
        {icon}
      </Box>
      <Typography variant="h5" color="text.secondary" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body1" color="text.secondary" textAlign="center">
        {subtitle}
      </Typography>
    </Box>
  );
}
